/**
 * Created by Mikhail Menshenin on 30.12.2025
 */

const simpleMetaGames = ["yatzy", "colorsort", "sorthaven", "tapaway", "jigsolitaire", "arrowsaway", "segmentsolitaire", "piecebypiece"];

// simple meta migration to location
if (simpleMetaGames.includes(cleverapps.config.name)) {
    DataVersion.MIGRATIONS.add(() => ({
        version: 6,

        migrateOnLoad: function () {
            const data = cleverapps.dataLoader.load(DataLoader.TYPES.META) || {};
            data.current = data.current || 0;

            const progress = cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_progress`);
            data.stars = progress || 0;

            let needsMigration = false;
            needsMigration = this.migrateFromOldData(data, cleverapps.dataLoader.load(DataLoader.TYPES.META) || {}) || needsMigration;
            needsMigration = this.migrateFromOldData(data, cleverapps.dataLoader.load(DataLoader.TYPES.SIMPLE) || {}) || needsMigration;
            needsMigration = this.migrateFromRpg(data, cleverapps.dataLoader.load(DataLoader.TYPES.ID) || {}) || needsMigration;

            if (needsMigration) {
                cleverapps.dataLoader.save(DataLoader.TYPES.META, data);
                cleverapps.dataLoader.save(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_progress`, data.stars);
            }
        },

        migrateOnSync: function (snapshot) {
            const data = cleverapps.clone(snapshot.metha || {}, true);
            data.current = data.current || 0;
            data.stars = snapshot.locations && snapshot.locations.progress || 0;

            let needsMigration = false;
            needsMigration = this.migrateFromOldData(data, snapshot.metha || {}) || needsMigration;
            needsMigration = this.migrateFromRpg(data, snapshot.users || {}) || needsMigration;

            if (needsMigration) {
                snapshot.metha = data;

                if (!snapshot.locations) {
                    snapshot.locations = {};
                }

                snapshot.locations.progress = data.stars;
            }
        },

        migrateFromOldData: function (data, oldData) {
            oldData.current = oldData.current || 0;
            oldData.stars = oldData.stars || 0;

            if (oldData.current > data.current) {
                data.current = oldData.current;
                data.stars = oldData.stars;
                return true;
            }

            if (oldData.current === data.current && oldData.stars > data.stars) {
                data.stars = oldData.stars;
                return true;
            }

            if (oldData.current !== data.current || oldData.stars !== data.stars) {
                return true;
            }
        },

        migrateFromRpg: function (data, userData) {
            if (cleverapps.config.rpg && !data.current && !data.stars && userData.episode > 0) {
                data.current = userData.episode;
                data.stars = 0;
                return true;
            }
        }
    }));
}

// simple meta migration to single location
if (simpleMetaGames.includes(cleverapps.config.name)) {
    DataVersion.MIGRATIONS.add(() => ({
        version: 7,

        migrateOnLoad: function () {
            const metaData = cleverapps.dataLoader.load(DataLoader.TYPES.META) || {};
            const stage = metaData.current || 0;

            cleverapps.dataLoader.save(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_stage`, stage);
        },

        migrateOnSync: function (snapshot) {
            const stage = snapshot.metha && snapshot.metha.current || 0;

            if (!snapshot.locations) {
                snapshot.locations = {};
            }

            snapshot.locations.stage = stage;
        }
    }));
}

// simple backward compatability
if (simpleMetaGames.includes(cleverapps.config.name)) {
    BackwardCompatibility.REGISTRATIONS.add(() => ({
        keys: [DataLoader.TYPES.META, `${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_progress`],

        onSave: (fromSever) => {
            const data = cleverapps.meta.getData();

            const slot = cleverapps.dataSlots.getSlot(Meta.SLOT_MAIN);
            const locationData = slot.getLocationInfo();
            data.current = locationData.stage || undefined;
            data.stars = locationData.progress || undefined;

            cleverapps.dataLoader.save(DataLoader.TYPES.SIMPLE, data);
            cleverapps.dataLoader.save(DataLoader.TYPES.META, data);

            if (!fromSever) {
                connector.synchronizer.addSendTask("metha");
                connector.synchronizer.addSendTask("locations");
            }
        },

        onSync: () => {
            const slot = cleverapps.dataSlots.getSlot(Meta.SLOT_MAIN);
            const locationData = slot.getLocationInfo();

            const data = cleverapps.meta.getData();
            data.current = locationData.stage;
            data.stars = locationData.progress;

            return data;
        }
    }));
}

// soft to hard + scale hard
DataVersion.registerSoftToHardConversion({
    forward: ["colorsort", "sorthaven", "tapaway", "jigsolitaire", "arrowsaway"],
    back: ["colorsort", "sorthaven", "tapaway", "jigsolitaire", "arrowsaway"]
});